import { UPDATE_DELIVERY_TYPE } from 'Constants/redux';

export const updateDeliveryType = (deliveryType) => (dispatch, getState) => {
  dispatch({ type: UPDATE_DELIVERY_TYPE, deliveryType });
};
